import { CSSProperties, FC, ReactNode } from 'react';
import { classNames } from '../../../utils';

interface CardContainerProps {
  header?: ReactNode;
  stripPadding?: boolean;
  className?: string;
  footer?: ReactNode;
  style?: CSSProperties;
  bodyClassName?: string;
  children?: ReactNode;
}

const CardContainer: FC<CardContainerProps> = ({
  bodyClassName,
  className,
  style,
  footer,
  header,
  stripPadding = false,
  children,
}: CardContainerProps) => {
  return (
    <div
      className={classNames(
        className ? className : 'bg-white rounded-lg shadow',
      )}
      style={style}
    >
      {header ? header : null}
      {children ? (
        stripPadding ? (
          <>{children}</>
        ) : (
          <div className={`px-8 py-6 ${bodyClassName ? bodyClassName : ''}`}>
            {children}
          </div>
        )
      ) : null}

      {footer ? footer : null}
    </div>
  );
};

export default CardContainer;
